import { addDays, formatDateLabel, todayLocal } from '#shared/dates'

interface Props {
  value: string
  onChange: (date: string) => void
  /** Today in the viewer's timezone; also the latest selectable date. */
  today: string
}

/**
 * Day selector for the timesheet: a native calendar plus arrows for stepping
 * a day at a time, which is how most retroactive logging actually happens.
 *
 * `type="date"` gives the platform's own calendar and keyboard handling for
 * free, rather than a hand-rolled one that has to be re-learned.
 */
export function DatePicker({ value, onChange, today }: Props) {
  const isToday = value === today

  return (
    <div className="date-picker">
      <button
        type="button"
        className="step"
        onClick={() => onChange(addDays(value, -1))}
        aria-label="Previous day"
      >
        ‹
      </button>

      <input
        type="date"
        value={value}
        max={today}
        onChange={(e) => e.target.value && onChange(e.target.value)}
        aria-label="Date"
      />

      <button
        type="button"
        className="step"
        onClick={() => onChange(addDays(value, 1))}
        aria-label="Next day"
      >
        ›
      </button>

      <span className="muted date-label">{formatDateLabel(value, today)}</span>

      {!isToday && (
        <button type="button" className="link" onClick={() => onChange(today)}>
          Jump to today
        </button>
      )}
    </div>
  )
}

export { todayLocal }
